// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});


export function storetile_mouseIn(event) {
	//Add your code for this event here: 
	$w("#storetile").src = 'wix:image://v1/9b8e0e_a3feced6e03b46aebb811a94b3db741e~mv2.jpg/tile-store-hover_edited.jpg#originWidth=180&originHeight=184';
}
export function storetile_mouseOut(event) {
	//Add your code for this event here:
	$w("#storetile").src = 'wix:image://v1/9b8e0e_1d8bedeeda064db5bace672186d81ba0~mv2.jpg/tile-store_edited.jpg#originWidth=180&originHeight=184';
}

export function auctiontile_mouseIn(event) {
	//Add your code for this event here: 
	$w("#auctiontile").src = 'wix:image://v1/9b8e0e_1a6d8e38b05c4c4caae5568a599ec60a~mv2.jpg/tile-auctions-hover_edited.jpg#originWidth=180&originHeight=184';
}
export function auctiontile_mouseOut(event) {
	//Add your code for this event here:
	$w("#auctiontile").src = 'wix:image://v1/9b8e0e_c70d2137549c42329fc364e6e01574e5~mv2.jpg/tile-auctions_edited.jpg#originWidth=180&originHeight=184' ;
}



export function cdsettile_mouseIn(event) {
	//Add your code for this event here: 
	$w("#cdsettile").src = 'wix:image://v1/9b8e0e_257035090e70405ea7b34003c91dfc33~mv2.jpg/tile-cd-set-hover_edited.jpg#originWidth=180&originHeight=184';
}
export function cdsettile_mouseOut(event) {
	//Add your code for this event here: 
	$w("#cdsettile").src = 'wix:image://v1/9b8e0e_d36cdfd1239841f6a2adcfadb5ace9ed~mv2.jpg/tile-cd-set_edited.jpg#originWidth=180&originHeight=184';
}



export function booktile_mouseIn(event) {
	//Add your code for this event here: 
	$w("#booktile").src = 'wix:image://v1/9b8e0e_d6c8a4d8f10f413388c6860a435b82c7~mv2.jpg/tile-book-hover_edited.jpg#originWidth=180&originHeight=184';
}
export function booktile_mouseOut(event) {
	//Add your code for this event here: 
	$w("#booktile").src = 'wix:image://v1/9b8e0e_e97041d937bc4480861331d7f6f43729~mv2.jpg/tile-book_edited.jpg#originWidth=180&originHeight=184';
}

export function newstile_mouseIn(event) {
	//Add your code for this event here: 
	$w("#newstile").src = 'wix:image://v1/9b8e0e_0db1dedc4280492aab3813be740ea8bd~mv2.jpg/tile-news-hover_edited.jpg#originWidth=180&originHeight=184';
}
export function newstile_mouseOut(event) {
	//Add your code for this event here: 
	$w("#newstile").src = 'wix:image://v1/9b8e0e_25a2efa9631744c1a0f87ac2e71ba548~mv2.jpg/tile-news_edited.jpg#originWidth=180&originHeight=184';
}

export function image3_click(event) {
	//Add your code for this event here: 
}